import { navigate } from "wouter/use-browser-location";
import { useTranslation } from "react-i18next";
import { useAuthWithTestMode } from "@/hooks/use-auth-with-test-mode";
import { ConnectionsList } from "@/components/connections-list";
import { Button } from "@/components/ui/button";
import { PageScaffold } from "@/components/page-scaffold";
import { goBackToConversation } from "@/lib/in-app-history";
import { Loader2, AlertCircle } from "lucide-react";

export function ConnectionsPage() {
  const { t } = useTranslation();
  const { user, isLoading, getAccessToken } = useAuthWithTestMode();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background text-foreground">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex h-screen items-center justify-center bg-background p-4 text-foreground">
        <div className="w-full max-w-md space-y-6 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-950/60">
            <AlertCircle className="h-8 w-8 text-amber-600 dark:text-amber-400" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-foreground">{t("connections:page.signInRequired")}</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              {t("connections:page.signInRequiredDescription")}
            </p>
          </div>
          <Button
            onClick={() => {
              navigate("/?return_to=" + encodeURIComponent(window.location.pathname + window.location.search));
            }}
            className="w-full"
          >
            {t("connections:page.signIn")}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <PageScaffold
      title={<h1 className="truncate text-sm font-semibold tracking-tight">{t("connections:page.title")}</h1>}
      backAriaLabel={t("common:actions.backToChat")}
      onBack={goBackToConversation}
      maxWidth="max-w-4xl"
      contentClassName="space-y-10"
    >
      <p className="text-sm text-muted-foreground">{t("connections:page.description")}</p>
      <ConnectionsList getToken={getAccessToken} />
    </PageScaffold>
  );
}
